import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

import constants from './constants';
import { ValueOf } from '../../GlobalTypes';

const { FILTER_OS_VALUE_ALL } = constants;

const {
  APP_STORAGE_KIND,
} = appStorageConstants;

export type FilterOsValue = ValueOf<typeof APP_STORAGE_KIND> | typeof FILTER_OS_VALUE_ALL;

const constructOsFilters = (filterValue: FilterOsValue)
: ValueOf<typeof appStorageConstants.APP_STORAGE_KIND>[] => (
  filterValue === FILTER_OS_VALUE_ALL ?
    [APP_STORAGE_KIND.IOS, APP_STORAGE_KIND.ANDROID] :
    [filterValue]
);

export default {
  constructOsFilters,
};
